import React from "react"
import {Box} from "@mui/material";

class ProgressRing extends React.Component {
    constructor(props) {
        super(props);
        const { radius, stroke } = this.props;
        this.normalizedRadius = (radius - stroke) / 2;
        this.circumference = this.normalizedRadius * 2 * Math.PI;
    }

    render() {

        const { radius, stroke, progress, color, circleProps, ...restProps } = this.props;
        const strokeDashoffset = this.circumference - progress / 100 * this.circumference;
        const circleStyles = {
            transition: 'stroke-dashoffset 0.35s',
            transform: 'rotate(-90deg)',
            transformOrigin: '50% 50%'
        }

        return (
                <Box
                    component="svg"
                    height={radius * 2}
                    width={radius * 2}
                    color={color && color}
                    stroke="currentColor"
                    {...restProps}>
                    <Box
                        component="circle"
                        stroke="inherit"
                        fill="transparent"
                        strokeWidth={ stroke }
                        strokeDasharray={ this.circumference + ' ' + this.circumference }
                        style={ { strokeDashoffset } }
                        r={ this.normalizedRadius }
                        {...circleProps} sx={circleProps?.sx ? {...circleStyles, ...circleProps.sx} : circleProps }/>
                </Box>
        );
    }
}
export default ProgressRing;